export const environment = {
  production: false,
  apiProjectUrl:
    "https://a314-projects-dev.rockport.avwaveinteractive.com/projects",
  apiUrlAdmin:
    "https://a314-admin-users-dev.rockport.avwaveinteractive.com/admin-users",
  apiGoogleStorage:
    "https://a314-google-storage-dev.rockport.avwaveinteractive.com/storage",
  urlStorage: "https://storage.googleapis.com/rockport-avwave-dev/",
  testUser: {
    // tslint:disable-line
    token: "cualquiercosa",
    email: "user@user.user",
  },
};
